import { render, staticRenderFns } from "./SignIcon.vue?vue&type=template&id=7568493a&scoped=true"
import script from "./SignIcon.vue?vue&type=script&lang=js"
export * from "./SignIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7568493a",
  null
  
)

export default component.exports